import {combineReducers} from "redux";
import fleetReducer from "./reducer";

const reducer = combineReducers({
    fleetReducer,
})
  
export default reducer;